import React from "react";
// Custom Select

// Mui
import Typography from "@mui/material/Typography";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { Box, FormControl, InputLabel, SxProps, Theme } from "@mui/material";

// Types
interface SelectOption {
  type: string;
  value?: string | number;
  [key: string]: any;
}

interface InputLabelCustomSelectProps {
  value: SelectOption;
  onChange: (event: SelectOption) => void;
  icon?: React.ElementType;
  title: string;
  options: SelectOption[];
  titleSx?: SxProps<Theme>;
  iconSx?: SxProps<Theme>;
  showSelected?: boolean;
}

const CustomInputLabelSelect: React.FC<InputLabelCustomSelectProps> = ({
  value,
  onChange,
  icon,
  title,
  options,
  titleSx,
  iconSx,
  showSelected = true,
}) => {
  return (
    <Box
      sx={{
        minWidth: 200,
        display: "flex",
        alignItems: "center",
        gap: "10px",
      }}
    >
      <Typography
        variant="body1"
        sx={titleSx}
        fontSize={"13px"}
        fontWeight={500}
      >
        {title}
      </Typography>
      <FormControl fullWidth variant="standard" size="small">
        {/* <InputLabel>{title}</InputLabel> */}
        <Select
          value={value}
          onChange={(e) => onChange(e.target.value as unknown as SelectOption)}
          label={title}
          IconComponent={icon}
          sx={{
            background: "transparent",
            ".MuiSelect-icon": iconSx as any,
          }}
          renderValue={(selected) =>
            showSelected ? (
              selected && typeof selected === "object" && "type" in selected ? (
                <Typography variant="body2" sx={titleSx} fontWeight={600}>
                  {(selected as SelectOption).type}
                </Typography>
              ) : (
                <Typography variant="body2" sx={titleSx} fontWeight={600}>
                  {title}
                </Typography>
              )
            ) : (
              <Typography variant="body2" sx={titleSx}>
                {title}
              </Typography>
            )
          }
        >
          {options?.map((option, idx) => (
            <MenuItem
              key={idx}
              value={option as any}
              sx={{
                fontSize: "11px",
                fontWeight: 400,
                lineHeight: "17px",
                textAlign: "left",
                color: "#181B25",
                mt: "4px",
                "&:hover": {
                  backgroundColor: "#DEEBF4",
                },
                "&.Mui-selected": {
                  backgroundColor: "#DEEBF4",
                },
              }}
            >
              {option.type}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default CustomInputLabelSelect;
